import { render, staticRenderFns } from "./groupFarm.vue?vue&type=template&id=7d981784&scoped=true"
import script from "./groupFarm.vue?vue&type=script&lang=js"
export * from "./groupFarm.vue?vue&type=script&lang=js"
import style0 from "./groupFarm.vue?vue&type=style&index=0&id=7d981784&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d981784",
  null
  
)

export default component.exports